import { HotelOwnerState } from '../../contexts/HotelOwnerContext';
import { IHotelOwner } from '../../types/entities/IHotelOwner';

export const adaptHotelOwnerToState = (
    hotelOwner: IHotelOwner
): HotelOwnerState => {
    return {
        id: hotelOwner.Id || '',
        signed: hotelOwner.Signed || false,
        zinantisMembership: hotelOwner.ZinantisMembership || false,
        idCurrency: hotelOwner.IdCurrency || 0,
        currency: hotelOwner.Currency?.Name || '',
    };
};
